/***
 * Debounce function
 * This function will delay the execution of the function passed to it
 * @param func - The function to be debounced
 * @param delay - The delay in milliseconds
 * @returns A debounced version of the function
 * */
export const debounce = (func: Function, delay: number) => {
  let timer: NodeJS.Timeout
  return (...args: any[]) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func(...args)
    }, delay)
  }
}
